import React, { useState } from "react";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { services } from "../mock";
import { useBooking } from "../App";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";

export default function Services() {
  const [active, setActive] = useState(null);
  const { openBooking } = useBooking();

  return (
    <section id="especialidades" className="section-navy text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <div className="max-w-2xl reveal">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-blue-300">
            Especialidades
          </span>
          <h2 className="font-display font-extrabold text-3xl lg:text-[2.6rem] leading-tight mt-4">
            Cuidamos y mejoramos tu salud visual
          </h2>
          <p className="text-blue-100/70 mt-4 leading-relaxed">
            Atención oftalmológica integral con diagnóstico preciso y tratamiento oportuno,
            desde la cirugía de alta complejidad hasta el cuidado estético periocular.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Eye;
            return (
              <button
                key={s.id}
                onClick={() => setActive(s)}
                className="reveal card-hover text-left group rounded-2xl p-7 glass-card hover:border-blue-400/50"
                style={{ transitionDelay: `${(i % 3) * 80}ms` }}
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl bg-blue-500/15 border border-blue-400/25 grid place-items-center text-blue-200">
                    <Icon size={22} />
                  </div>
                  <ArrowUpRight
                    size={20}
                    className="text-blue-200/50 group-hover:text-blue-200 transition-colors"
                  />
                </div>
                <h3 className="font-display font-bold text-lg mt-5">{s.title}</h3>
                <p className="text-sm text-blue-100/65 mt-2 leading-relaxed">{s.short}</p>
              </button>
            );
          })}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-lg">
          {active && (
            <>
              <DialogHeader>
                <div className="w-12 h-12 rounded-xl bg-[#e8f2fd] grid place-items-center text-[#1d6fc0] mb-2">
                  {(() => {
                    const Icon = Icons[active.icon] || Icons.Eye;
                    return <Icon size={22} />;
                  })()}
                </div>
                <DialogTitle className="font-display text-xl text-[#0b2545]">
                  {active.title}
                </DialogTitle>
              </DialogHeader>
              <p className="text-sm text-slate-600 leading-relaxed">{active.desc}</p>
              <div className="flex flex-wrap gap-2 mt-2">
                {active.tags.map((t) => (
                  <span
                    key={t}
                    className="text-xs font-medium px-3 py-1 rounded-full bg-[#e8f2fd] text-[#1d6fc0]"
                  >
                    {t}
                  </span>
                ))}
              </div>
              <Button
                onClick={() => {
                  setActive(null);
                  openBooking();
                }}
                className="mt-4 w-full rounded-full bg-[#1d6fc0] hover:bg-[#175a9e]"
              >
                Reservar hora para esta especialidad
              </Button>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
